import { Skeleton } from "~/components/ui/skeleton";

/**
 * プロフィール読み込み中のスケルトン。
 * 実画面（TopBar → 写真カルーセル → Identity → カード群）の骨格を
 * グレー基調でなぞり、データ着信時の見た目の差を最小にする。
 */
export const UserProfileSkeleton = () => {
  return (
    <div className="mx-auto flex min-h-screen max-w-md flex-col bg-zinc-100">
      {/* TopBar: 戻る / ブックマーク / メニューの円形コントロール位置 */}
      <div className="flex items-center justify-between px-3 pt-3 pb-2">
        <Skeleton className="size-9 rounded-full bg-zinc-200" />
        <div className="flex gap-2">
          <Skeleton className="size-9 rounded-full bg-zinc-200" />
          <Skeleton className="size-9 rounded-full bg-zinc-200" />
        </div>
      </div>

      {/* 写真カルーセル領域 */}
      <Skeleton className="aspect-[3/3.2] w-full rounded-t-3xl bg-zinc-200" />

      {/* Identity: 名前 / 年齢・地域 / バッジ */}
      <div className="px-5 pt-5 pb-2">
        <Skeleton className="h-8 w-40 bg-zinc-200" />
        <Skeleton className="mt-2.5 h-4 w-32 bg-zinc-200" />
        <Skeleton className="mt-2.5 h-6 w-24 rounded-full bg-zinc-200" />
      </div>

      {/* カード群 */}
      <div className="flex flex-col gap-3 px-3.5 pt-3 pb-28">
        <Skeleton className="h-24 w-full rounded-2xl bg-zinc-200" />
        <Skeleton className="h-32 w-full rounded-2xl bg-zinc-200" />
        <Skeleton className="h-40 w-full rounded-2xl bg-zinc-200" />
      </div>
    </div>
  );
};
